import { makeStyles } from "@material-ui/core/styles";
import { T } from "./constants";

/* Join truthy class names (avoids adding a clsx dependency). */
export const cx = (...a) => a.filter(Boolean).join(" ");

/* ---------- Shared controls / type classes ---------- */

export const useUi = makeStyles({
  eyebrow: { fontSize: 11, textTransform: "uppercase", color: T.subtleFg },
  eyebrowSm: { fontSize: 10, textTransform: "uppercase", color: T.subtleFg },
  eyebrowXs: { fontSize: 9, textTransform: "uppercase", color: T.subtleFg },
  field: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${T.border}`,
    background: T.elevated,
    padding: "8px 12px",
    fontSize: 14,
    color: T.fg,
    outline: "none",
    fontFamily: "inherit",
    "&:focus": { borderColor: T.primary, boxShadow: `0 0 0 2px ${T.primaryTint}` },
    "&::placeholder": { color: T.subtleFg },
  },
  primaryBtn: {
    borderRadius: 6,
    border: "none",
    background: T.primary,
    color: T.primaryFg,
    fontWeight: 600,
    fontSize: 14,
    padding: "10px 20px",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "filter .15s ease",
    "&:hover": { filter: "brightness(1.1)" },
    "&:disabled": { opacity: 0.4, cursor: "not-allowed", filter: "none" },
  },
  ghostBtn: {
    borderRadius: 6,
    border: `1px solid ${T.border}`,
    background: T.elevated,
    color: T.fg,
    fontWeight: 500,
    fontSize: 13,
    padding: "8px 12px",
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": { background: T.surface },
    "&:disabled": { opacity: 0.4, cursor: "not-allowed" },
  },
  /* The x in a panel's top-right corner. Square, quiet, and the same in every
     modal so the desk never has to look for it. */
  closeBtn: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: 6,
    border: "none",
    background: "transparent",
    color: T.mutedFg,
    fontSize: 20,
    lineHeight: 1,
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": { background: T.surface, color: T.fg },
    position: "relative",
    top: -12,
    right: -12,
  },
  mutedBtn: {
    borderRadius: 6,
    border: `1px solid ${T.border}`,
    background: T.surface,
    color: T.mutedFg,
    fontSize: 13,
    padding: "8px 12px",
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": { background: T.muted },
    "&:disabled": { opacity: 0.4, cursor: "not-allowed" },
  },
});
